import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import moment from 'moment-with-locales-es6';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Profile from './profile';
import FriendProfile from './friendProfile';
import Footer from '../components/footer/footer';
import Dashboard from '../view/dashboard';
import Measures from '../view/measures';
import Newsline from '../view/newsline';
import NavMenu from '../components/menu/NavMenu';
import Registration from '../containers/registration';
import GuardianPageContainer from '../containers/guardianPageContainer';
import Guardians from '../components/guardians';
import Messenger from '../view/messenger';
import { login } from '../helpers/registrationHelper';

class Main extends Component {

  componentDidMount() {

    let uid = localStorage.getItem('uid');
    let expiry = localStorage.getItem('expiry');
    let twilioToken = localStorage.getItem('token_chat');

    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 14);
    expirationDate.setSeconds(expirationDate.getSeconds() + 14);
    const { history } = this.props;

    let lastLogin = moment(localStorage.getItem('lastLoginDate'));
    let expiryDate = moment(localStorage.getItem('expiry') * 1000)

    if (uid && uid.length > 0 && moment(expiry).isAfter(moment()) && history && window.location.href.split('/')[window.location.href.split('/').length - 1] === '' && twilioToken) {
      history.push('dashboard');
    } else if (moment.duration(expiryDate.diff(lastLogin)).asMinutes() >= 1) {
      history.push('/')
    }

    window.addEventListener('load', this.refreshToken());
  }

  refreshToken = () => {
    const params = { email: localStorage.uid, password: localStorage.password }
    login(params).then((data) => {
      if (data.data.errors) {
        this.setState({ errors: data.errors })
      } else if (data.headers.expiry && data.headers.client && data.headers.client && data.headers["access-token"]) {
        let lastLogin = moment()
        localStorage.setItem("expiry", data.headers.expiry);
        localStorage.setItem("uid", data.headers.uid);
        localStorage.setItem("client", data.headers.client);
        localStorage.setItem("accessToken", data.headers["access-token"]);
        localStorage.setItem("user_id", data.data.data.id);
        localStorage.setItem("name", data.data.data.name);
        localStorage.setItem("token_chat", data.data.data.token_jwt_chat);
        localStorage.setItem("lastLoginDate", lastLogin)

        if (localStorage.user_id) {
          setTimeout(() => {
            this.setState({ redirectToDashboard: false })
            this.handleLogin()
          }, 900000)
        }

        if (this.props.history.location.pathname === "/") {
          this.props.history.push('/dashboard')
        }
      }

    })
  }


  render() {
    let uid = localStorage.getItem('uid')
    return (
      <div className="app">
        {uid && uid.length > 0 && window.location.href.split('/')[window.location.href.split('/').length - 1] !== '' &&
          <NavMenu {...this.props} />
        }
        <div id="app-body">
          <main className="main">
            {uid && uid.length > 0 && window.location.href.toLowerCase().split('/').indexOf('dashboard') !== -1 && window.location.href.toLowerCase().split('/')[window.location.href.toLowerCase().split('/').length - 1] !== '' &&
              <Guardians moduleType="BANNER" {...this.props} />
            }
            {uid && uid.length > 0 && window.location.href.toLowerCase().split('/')[window.location.href.toLowerCase().split('/').length - 1] !== '' && <Messenger />}
            <Container fluid>
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard} />
                <Route path="/Measures" name="Measures" component={Measures} />
                <Route path="/Newsline" name="Newsline" component={Newsline} />
                <Route path="/Network" name="Network" component={GuardianPageContainer} />
                <Route path="/profile" name="Profile" component={Profile} />
                <Route path="/friendProfile" name="FriendProfile" component={FriendProfile} />
                <Route path="/" exact name="Registration" component={Registration} />
              </Switch>
            </Container>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

Main.propTypes = {
  history: PropTypes.object
};


export default withRouter(Main);


// WEBPACK FOOTER //
// ./src/containers/main.js